export const table = {
  selectedPlural: "Selecionados",
  selectedSingle: "Selecionado"
};
